module.exports = __webpack_public_path__ + "img/ondoll_02.102f34aa.png";